function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.26057 6.36305e-07L4.38141 7.62157e-07L9.14222 4.9625L-1.00285e-07 4.9625L-8.58211e-09 7.06042L9.14222 7.06042L4.4033 12L7.26057 11.9999L13 6.01146L7.26057 6.36305e-07Z",
  fill: "currentColor"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMyAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMjYwNTcgNi4zNjMwNWUtMDdMNC4zODE0MSA3LjYyMTU3ZS0wN0w5LjE0MjIyIDQuOTYyNUwtMS4wMDI4NWUtMDcgNC45NjI1TC04LjU4MjExZS0wOSA3LjA2MDQyTDkuMTQyMjIgNy4wNjA0Mkw0LjQwMzMgMTJMNy4yNjA1NyAxMS45OTk5TDEzIDYuMDExNDZMNy4yNjA1NyA2LjM2MzA1ZS0wN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };